import ListItem from '../ListItem/ListItem';
import { IContactList } from '../../interfaces';

const titles = 
{
    email: 'Email',
    facebook: 'Facebook Messenger',
    whatsapp: 'WhatsApp',
    phone: 'Work telephone number',
    mobile: 'Cell telephone number',
    linkedin: 'LinkedIn',
    googleBusinessMessage: 'Google Business Message',
    website: 'Website'
}

function ContactsList({ contacts } : { contacts: IContactList })
{
    return (
        <div style = {{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style = {{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {
                Object.entries(contacts)
                    .filter(([key, value]) => value && value.trim() !== '')
                    .map(([key, value]) => (
                        <ListItem
                            key = {key}
                            title = {Object(titles)[key]}
                            value = {value}
                        />
                    ))
            }
            </div>
        </div>
    )
}

export default ContactsList;